// 🔧 entry_step.js
// ✅ Purpose: Entry Builder pipeline step
// ✅ Features:
// - Executes the Entry Builder
// - Updates DemoContext
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";
import { buildEntryShell } from "../../builders/entry_builder";

export const createEntryStep = () => ({
  name: "entry_builder",

  label: "Entry Builder",

  run: async (context) => {
    const result =
      await buildEntryShell(context);

    return createPipelineStepSuccess({
      step: "entry_builder",

      label: "Entry Builder",

      created:
        result?.createdCount ||
        result?.plannedCount ||
        0,

      message: result?.message,

      metadata: result,

      startedAt: context.startedAt,
    });
  },

  afterSuccess: ({
    result,
    sharedContext,
  }) => {
    sharedContext.entryResult =
      result?.metadata || null;

    sharedContext.entries =
      result?.metadata?.createdEntries ||
      [];
  },
});